import {useState} from 'react';
import {useQuery} from 'react-query';
import {apiService} from 'services/ApiService';
import Card from '../../../../components/Card/Card';
import CardBody from '../../../../components/Card/CardBody';
import {ListItem, Skeleton, UnorderedList} from '@chakra-ui/react';
import Pagination from '../../../../components/Pagination';
import NotFound from '../../404';
import GiveawayLogItem from './GiveawayLogItem';

const GiveawaysLogs = ({giveawayId}) => {

    const limit = 30;
    const [logs, setLogs] = useState([]);
    const [logsMeta, setLogsMeta] = useState([]);
    const [offset, setOffset] = useState(0);
    const [isLoadingPage, setIsLoadingPage] = useState(false);

    const { isLoading, isFetching } = useQuery({
        queryKey: ['giveawayLogs', offset, giveawayId, limit],
        refetchOnWindowFocus: false,
        queryFn: async () => {
            const response = await apiService.getGiveawayWinnersLogs({
                parentItemType: 'giveaway',
                parentItemId: giveawayId,
                limit,
                offset,
            });

            setLogs(response.data);
            setIsLoadingPage(false);
            setLogsMeta(response.meta);
            return true;

        }
    });

    console.log(Math.floor(offset / limit) + 1);

    return (
        <div>
            {logs.length > 0 ? (
                <Card padding="8px 0 28px 0" overflow="hidden">
                    <CardBody p='4' flexDir='column' opacity={isLoadingPage ? '0.3' : '1'}>
                       <UnorderedList>
                           {logs.map(log =>
                               <ListItem key={log.id}>
                                   <GiveawayLogItem log={log}/>
                               </ListItem>
                           )}

                       </UnorderedList>

                    </CardBody>

                    <Pagination
                        meta={logsMeta}
                        isLoadingPage={isLoadingPage}
                        setIsLoadingPage={setIsLoadingPage}
                        currentPage={Math.floor(offset / limit) + 1}
                        onPageChange={(newOffset) => setOffset(newOffset)}
                    />
                </Card>
            ) : !isLoading && logs.length === 0 ? (
                <NotFound text={isFetching ? 'Loading...' : 'Not found'} />
            ) : (
                <>
                    <Skeleton borderRadius="16px" h="70px" mb="5px" />
                    <Skeleton borderRadius="16px" h="70px" mb="5px" />
                    <Skeleton borderRadius="16px" h="70px" />
                </>
            )}
        </div>
    );
};

export default GiveawaysLogs;